import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { PostFileData } from "@/types";
import PostFileItem from "@/components/PostFileItem";

interface Props {
  files: (PostFileData | ContentFile)[];
  underline: boolean;
}

export default Vue.extend({
  functional: true,
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { files, underline } = ctx.props;
    return (
      <div class={ctx.data.class} staticClass={ctx.data.staticClass || "" + "post-file-list"}>
        <div staticClass={"post-file-list__rows my-2 mx-n4"}>
          {files.map(file => (
            <PostFileItem
              class={{ __underline: underline }}
              staticClass={"post-file-list__row px-4"}
              postFile={file}
              key={file.id}
              scopedSlots={{
                ...((ctx.scopedSlots.itemPrepend && { prepend: ctx.scopedSlots.itemPrepend }) || {}),
                ...((ctx.scopedSlots.itemAppend && { append: ctx.scopedSlots.itemAppend }) || {}),
                ...((ctx.scopedSlots.itemFileHeader && { header: ctx.scopedSlots.itemFileHeader }) || {}),
              }}
            />
          ))}
        </div>
      </div>
    );
  },
});
